<div class="ghost-add-to-cart-container">
  <div class="price"></div>
  <div class="add-to-cart"></div>
</div>
